import React from 'react';
import Footer from '../Footer';
import Cards from '../Cards';

function Portfolio() {
    window.scrollTo(0,0);
    return(
        <>
            <Cards/>
            <Footer/>
        </>
    )
}

export default Portfolio
